import { useForm } from '../../../../../lib/refine';

const FormController = ({ children, userId, closeModal, initialValues }) => {
  const { formProps } = useForm({
    resource: 'users/password-changes',
    action: 'create',
    id: userId,
    meta: {
      userId,
    },
    successNotification: 'Password has been updated',
    onMutationSuccess: (user) => {
      closeModal();
    },
  });
  return children({
    formProps: {
      ...formProps,
      initialValues,
    },
  });
};

export default FormController;
